import React from 'react';
import cls from 'classnames';

import '../Styles/about.css';
import { NavLink } from 'react-router-dom';
import image from '../Assets/Images/image.jpg';

const About = () => {
  return (
    <div className='container section-margin-top'>
      <div className='flex justify-center'>
        <img
          placeholder='blurred'
          className={cls('shadow-md', 'devphoto')}
          width={400}
          src={image}
          alt='Umad Ahmad'
        />
      </div>
      <article
        className='mb-10 mt-16 prose prose-lg prose-purple '
        style={{
          textAlign: 'left',
        }}
      >
        <h1 className='text-2xl sm:text-4xl lg:text-5xl leading-none font-extrabold text-white tracking-tight'>
          About me
        </h1>
        <div className='max-w-4xl text-lg font-medium text-white sm:leading-9'>
          <p>
            I'm a full stack web developer and a freelancer since a year.I am
            specialized in MERN Technology. I've a small team of MERN
            Developers. We can build your app with best design, professional
            performance, high quality code and best deployment with full
            testing.
          </p>
        </div>

        <h2 className='text-xl sm:text-3xl lg:text-4xl leading-none font-extrabold text-white tracking-tight'>
          Get in touch
        </h2>
        <p className='max-w-4xl text-lg font-medium text-white sm:leading-9'>
          The easiest way is to send me a message on{' '}
          <a href='https://www.linkedin.com/in/uahmadsoft' target='_blank'>
            LinkedIn
          </a>{' '}
          I'll usually respond <b>within 48 hours</b>. Otherwise{' '}
          <NavLink to='/contact'>here's</NavLink> all my social media links.
        </p>

        <h2 className='text-xl sm:text-3xl lg:text-4xl leading-none font-extrabold text-white tracking-tight'>
          Tech stack
        </h2>
        <p className='max-w-4xl text-lg font-medium text-white sm:leading-9'>
          I work in <b>Javascript</b> and usually use <b>ReactJS</b> to create
          websites. My skills include -
        </p>

        <ul>
          <li>
            <strong>Frontend</strong> -{' '}
            <em>
              React Js, Redux Toolkit, Firebase, Material UI, Tailwind CSS,
              Bootstrap, HTML CSS JS and other technologies.
            </em>
          </li>
          <li>
            <strong>Backend</strong> - <em>Node.js, Express ,MongoDB</em>
          </li>
        </ul>
        <p>
          I always keep myself up to date with the everchanging tech industry. I
          can quickly integrate with any tech stack and have experience using
          all major state management and styling paradigms.
        </p>

        <h2 className='text-xl sm:text-3xl lg:text-4xl leading-none font-extrabold text-white tracking-tight'>
          What you can expect
        </h2>
        <p className='max-w-4xl text-lg font-medium text-white sm:leading-9'>
          I am fast and meticulous. You can always expect
        </p>
        <ul>
          <li>
            <strong>Responsive website</strong> -{' '}
            <em>
              ~70% of traffic comes from mobile devices. Great mobile UX and
              fast loading speeds will have a positive impact on conversion
              rates. I build websites that are responsive and provide great user
              experience in almost all kinds of devices with various screen
              sizes.
            </em>
          </li>
          <li>
            <strong>High Performance</strong> -{' '}
            <em>
              Performance is very important for a WebApp. I completely ensure
              the best performance of my Apps by using good technologies like
              Redis, AWS, Docker, Lazy-loading React App and much more.
            </em>
          </li>
          <li>
            <strong>Maintainable code</strong> -{' '}
            <em>
              Meticulously commented code, well-named variables and small
              components will allow your team to extend my work easily while
              also making the codebase maintainable in the long run.
            </em>
          </li>
          <li>
            <strong>Anti-bug guarantee</strong> -{' '}
            <em>
              Bugs happen. If they happen within 2 months after my contract
              ends, I'll fix them for free.
            </em>
          </li>
        </ul>
        <h2 className='text-xl sm:text-3xl lg:text-4xl leading-none font-extrabold text-white tracking-tight'>
          What I don't do
        </h2>
        <ul>
          <li>
            <strong>Typescript and Next Js</strong> -{' '}
            <em>
              Right Now I am unable to work with Typescript. However on my plan,
              from June 2022 I'll be able work with Typescript, Next Js, and
              some more Technologies
            </em>
          </li>
        </ul>
      </article>
    </div>
  );
};

export default About;
